import { render, staticRenderFns } from "./shippingFee.vue?vue&type=template&id=523052e9"
import script from "./shippingFee.js?vue&type=script&lang=js&external"
export * from "./shippingFee.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports